import React, { useEffect, useState } from "react";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import Moment from "react-moment";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../store/auth";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerDetails, loadPartnerDetails } from "../store/partner";
import { getAppTasks, getCandidateApps, loadAppRuningTasks, loadCandidateApps } from "../store/candidate";

export default function PartnerInfo() {

    const [partnerDetails, setPartnerDetails] = useState(null);
    const [wfTask, setWfTask] = useState(null);

    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const partnerDetailsSelector = useSelector(getPartnerDetails);
    const candidateAppsSelector = useSelector(getCandidateApps);
    const appTasksSelector = useSelector(getAppTasks);

    const currentUser = getCurrentUser();
    const dispatch = useDispatch();

    useEffect(() => {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
            usrId = currentUser.linkUser;

        if (!userDetailsSelector)
            dispatch(loadUserDetails(usrId));

        if (candidateAppsSelector.length === 0 && currentUser?.id > 0)
            dispatch(loadCandidateApps(usrId))
    }, []);

    // useEffect(() => {
    //     console.log("partnerDetailsSelector", partnerDetailsSelector);
    //     if (userDetailsSelector?.partnerid && !partnerDetailsSelector) {
    //         dispatch(loadPartnerDetails(userDetailsSelector.partnerid))
    //     }
    // }, [userDetailsSelector]);

    useEffect(() => {
        if (candidateAppsSelector.length > 0 && currentUser?.id > 0) {
            const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
            if (mainWorkflow.length > 0) {
                const wf = mainWorkflow[0];
                let usrId = currentUser.id;
                if (currentUser.linkUser)
                    usrId = currentUser.linkUser;
                if (currentUser?.id > 0) {
                    dispatch(loadAppRuningTasks(wf.oldWorkflowId, usrId));
                }

            }
        }
    }, [candidateAppsSelector]);

    useEffect(() => {
        if (appTasksSelector.length > 0) {
            const filterTasks = appTasksSelector.filter(x => x.taskType === 1 && x.wiid > 0);
            if (filterTasks.length > 0)
                setWfTask(filterTasks[0]);
        }
    }, [appTasksSelector]);

    useEffect(() => {
        setPartnerDetails(partnerDetailsSelector);
    }, [partnerDetailsSelector]);

    const usrType = localStorage.getItem("userType");

    const getParterAddress = () => {
        let ddType = "recruiterenrollmentform";
        if (usrType === "subcontractor") ddType = "subcontractorenrollmentform";

        let add1 = getFieldData(wfTask.stateData, ddType, "Company_Address_Line1");
        let add2 = getFieldData(wfTask.stateData, ddType, "Company_Address_Line2");
        let city = getFieldData(wfTask.stateData, ddType, "Company_City");
        let state = getFieldData(wfTask.stateData, ddType, "Company_State");
        let zip = getFieldData(wfTask.stateData, ddType, "Company_Zip_Code");
        let country = getFieldData(wfTask.stateData, ddType, "Company_Country");

        return <>
            {add1 && <p>{add1}</p>}
            {add2 && <p>{add2}</p>}
            {city && <span>{city}, </span>}
            {state && <><span>{state}</span><br /></>}
            {zip && <span>{zip}, </span>}
            {country && <span>{country}</span>}
        </>
    }

    let item = "";
    if (partnerDetails)
        item = partnerDetails;

    return <React.Fragment>
        <div className="table-responsive border border-top-0">
            <table className="table align-items-center table-flush table-hover table-striped mb-2">
                <thead className="thead-light">
                    <tr>
                        <th className="border-top-0">ID</th>
                        <th className="border-top-0">{usrType}</th>
                        <th className="border-top-0">Date & Time</th>
                        <th className="border-top-0">Address</th>
                        <th className="border-top-0">Key Contact</th>
                        <th className="border-top-0">Active Users</th>
                    </tr>
                </thead>
                <tbody>

                    {item !== "" && (
                        <tr>
                            <td>{item.fuid}</td>
                            <td>
                                <span className="text-uppercase">{item.label}</span>
                                <br />
                                <span>
                                    {wfTask && usrType === "recruiter" && getFieldData(wfTask.stateData, "recruiterenrollmentform", "Company_Email")}
                                    {wfTask && usrType === "subcontractor" && getFieldData(wfTask.stateData, "subcontractorenrollmentform", "Company_Email")}
                                </span>
                                <br />
                                {wfTask && usrType === "recruiter" && getFormatedNumber(getFieldData(wfTask.stateData, "recruiterenrollmentform", "Company_Phone"))}
                                {wfTask && usrType === "subcontractor" && getFormatedNumber(getFieldData(wfTask.stateData, "subcontractorenrollmentform", "Company_Phone"))}
                            </td>

                            <td>
                                <Moment format="MMM Do YYYY">{item.createdDate}</Moment>
                                <br />
                                <Moment format="h:mm a">{item.createdDate}</Moment>
                            </td>
                            <td>
                                {/* {item.portalUrl} {item.state} <br />
                                {item.city} {item.zip} */}

                                {wfTask && getParterAddress()}
                            </td>
                            <td>
                                {item.contact1 && (
                                    <React.Fragment>
                                        <span className="text-uppercase">
                                            {item.contact1.performername} {item.contact1.lastName}
                                        </span>
                                        <br />
                                        <span>
                                            {item.contact1.performeremail}
                                        </span>
                                        <br />
                                        {item?.contact1?.contactNo && getFormatedNumber(item.contact1.contactNo)}
                                    </React.Fragment>
                                )}
                            </td>
                            <td>
                                {item.activeUsers}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    </React.Fragment>
}